<template>
  <v-app>
    <v-container fluid>
      <v-row >
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Others Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form
                  @submit.prevent="submitForm(currentStatus)"
                  ref="addPurOrder"
                  id="addPurOrder"
                >
                  <v-row class="pa-2">
                    <v-col cols="12">

                      <v-text-field
                        :reverse="false"
                        controlVariant="stacked"
                        label="Reference No"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="ref_no.value.value"
                        hide-details
                      ></v-text-field>

                      <v-autocomplete
                        class="mt-4"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="requisition_type.value.value"
                        :items="getRequisitionTypeList()"
                        :item-title="(item) => `${item.label}`"
                        item-value="value"
                        @update:modelValue="onRequisitionTypeChange"
                        :error-messages="requisition_type.errorMessage.value"
                        autocomplete="off"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Requisition Type
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        v-if="evaluationSelection"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="csQuotationEvaluation.value.value"
                        :items="getSelectedCsQuotationEvaluationList"
                        :item-title="(item) => `${item.code}`"
                        return-object
                        @update:modelValue="onQuotationChange"
                        :error-messages="csQuotationEvaluation.errorMessage.value"
                        autocomplete="off"
                        :disabled="isEditMode"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          CS Evaluation
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        v-if="cncMergeSelection"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="req_merge_master_id.value.value"
                        :items="getOrderablePurRequisitionMergeList"
                        :item-title="(item) => `${item.code}`"
                        item-value="id"
                        @update:modelValue="onCncChange"
                        :error-messages="req_merge_master_id.errorMessage.value"
                        autocomplete="off"
                        :disabled="isEditMode"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Requisition Merge
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        v-if="requsitionSelection"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="requsition_master_id.value.value"
                        :items="getOrderablePurchaseRequisitionList"
                        :item-title="(item) => `${item.code}`"
                        item-value="id"
                        @update:modelValue="onRequesitionChange"
                        :error-messages="requsition_master_id.errorMessage.value"
                        autocomplete="off"
                        :disabled="isEditMode"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Purchase Requisition
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>


                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="warehouse_id.value.value"
                        :items="getWarehouseList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="warehouse_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Warehouse
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>


                      
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="purpose_id.value.value"
                        :items="getPurposeList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="purpose_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Purpose/Project
                          <span class="text-red-accent-4"></span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        label="Purchase Order Type"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="purchase_type.value.value"
                        :items="types"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="purchase_type.errorMessage.value"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="supplier_id.value.value"
                        :items="getSupplierList"
                        :item-title="item => `${item.name}-(${item.type.name})` ?? 'N/A'"
                        item-value="id"
                        :error-messages="supplier_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                        @update:modelValue="onSupplierChange"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Supplier Name
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="procurer_id.value.value"
                        :items="getEmployeeList"
                        :item-title="item => `${item.name}-(${item.code})` ?? 'N/A'"
                        item-value="id"
                        :error-messages="procurer_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Procurer
                          <span class="text-red-accent-4"></span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete 
                        variant="outlined" 
                        density="compact"
                        bg-color="grey-lighten-4" 
                        v-model="payment_bank_id.value.value"
                        :items="getLcBankList" 
                        :item-title="item => `${item.name}-${item.branch}` ?? 'N/A'"
                        item-value="id" 
                        :error-messages="payment_bank_id.errorMessage.value" 
                        autocomplete="off"
                        clearable
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                            Payment Bank
                            <!-- <span class="text-red-accent-4">*</span> -->
                        </template>
                      </v-autocomplete>

                      <v-date-input 
                        input-format="dd/mm/yyyy"
                        label="Purchase Order Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="purchase_date.value.value"
                        :error-messages="purchase_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>

                      <v-date-input 
                        input-format="dd/mm/yyyy"
                        label="Shipping Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="shipping_date.value.value"
                        :error-messages="shipping_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>

                      <v-text-field
                        label="Rfq By"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="purOrder_by.value.value"
                        :error-messages="purOrder_by.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>

                      <v-text-field
                        label="Rfq By Mobile"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="purOrder_by_mobile.value.value"
                        :error-messages="purOrder_by.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>

                      <v-text-field
                        label="Rfq By Email"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="purOrder_by_email.value.value"
                        :error-messages="purOrder_by_email.errorMessage.value"
                        :disabled="true"
                        autocomplete="off"
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Item Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form
                  @submit.prevent="submitForm(currentStatus)"
                  ref="addPurOrder"
                  id="addPurOrder"
                >
                  <v-row v-if="addProduct" class="pt-2 justify-center">
                    <v-col cols="8">
                      <v-autocomplete
                        class=""
                        label="Search Product Name"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="product_id.value.value"
                        :items="getProductMapList"
                        :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                        item-value="product_id"
                        :error-messages="product_id.errorMessage.value"
                        @update:model-value="addCart"
                        @keydown.enter="addCart"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                      <input
                        v-model="pur_order_master_id.value.value"
                        type="hidden"
                      />
                    </v-col>

                    <!-- <v-col cols="1">
                      <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                    </v-col> -->
                  </v-row>

                  <!-- Cart Table -->
                  <v-row class="pt-0">
                    <v-col cols="12">
                      <!-- <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom" style="height:40vh; overflow-y: scroll;"> -->
                      <v-table
                        density="compact"
                        :loading="loading"
                        fixed-header
                        class="table-dotted-border-bottom"
                      >
                        <!-- style="height:40vh; overflow-y: scroll;" -->
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 5%">SL</th>

                            <th class="text-center" style="width: 20%">Product Code</th>
                            <th class="text-left" style="width: 25%">
                              Product Name
                            </th>
                            <th class="text-center" style="width: 10%">
                              Quantity
                            </th>
                             <th v-if="isFreeItem" class="text-center" style="width: 10%">
                              Free Quantity
                            </th>
                            <th class="text-center" style="width: 15%">Unit</th>

                            <th class="text-center" style="width: 15%">
                              Price
                            </th>

                            <th class="text-center" style="width: 15%">
                              Amount
                            </th>

                            <th class="text-right" style="width: 5%">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            v-for="(item, index) in cart"
                            v-if="cart.length > 0"
                            :key="index"
                          >
                            <td class="text-center py-1">{{ index + 1 }}</td>

                            
                            <td
                              class="text-left py-1"
                              style="white-space: normal"
                            >
                              {{ item.product_code }}
                            </td>

                            <td
                              class="text-left py-1"
                              style="white-space: normal"
                            >
                              {{ item.product_name }}
                            </td>

                            <td class="text-right py-2">
                              <v-text-field
                                :reverse="false"
                                controlVariant="stacked"
                                style="width: 100px"
                                label=""
                                :hideInput="false"
                                :inset="false"
                                :min="1"
                                type="number"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="item.qty"
                                hide-details
                                :error="item.qty < 1"
                                :error-messages="
                                  item.qty < 1
                                    ? 'Quantity must be greater than 0'
                                    : ''
                                "
                                @update:model-value="
                                  item.total = item.qty * item.rate
                                "
                                @blur="item.total = item.qty * item.rate"
                              ></v-text-field>
                            </td>


                            <td v-if="isFreeItem" class="text-right py-2">
                              <v-text-field
                                :reverse="false"
                                controlVariant="stacked"
                                style="width: 100px"
                                label=""
                                :hideInput="false"
                                :inset="false"
                                :min="1"
                                type="number"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="item.free_qty"
                                hide-details
                              ></v-text-field>
                            </td>
                            
                            <td class="text-center py-1">
                              {{ item.unit_name }}
                            </td>

                            <td class="text-center py-1">
                              <v-text-field
                                  :reverse="false"
                                  controlVariant="stacked"
                                  style="width:120px;"
                                  label=""
                                  :hideInput="false"
                                  :inset="false"
                                  :min="1"
                                  type="number"
                                  density="compact"
                                  variant="outlined"
                                  bg-color="grey-lighten-4"
                                  v-model="item.rate"
                                  hide-details
                                  :error="item.rate < 1"
                                  :error-messages="item.qty < 1 ? 'rate must be greater than 0' : ''"
                                  @update:model-value="item.total = item.qty * item.rate"
                              >
                                <!-- Replace the prop with this slot template -->
                                <template #prepend-inner>
                                  <v-icon
                                      style="font-size: 16px"
                                      :icon="getCurrencyIcon(purchase_type.value.value)"
                                  ></v-icon>
                                </template>
                              </v-text-field>
                            </td>

                            <td class="text-center py-1" style="white-space: nowrap;">
                              <v-icon size="small">{{ getCurrencyIcon(purchase_type.value.value) }}</v-icon>{{ this.$numberFormat(item.total) }}
                            </td>

                            <td class="text-center py-1">
                              <v-icon
                                size="small"
                                color="red"
                                class="delete-button"
                                @click="removeFromCart(index)"
                              >
                                mdi-delete
                              </v-icon>
                            </td>
                          </tr>

                          <tr v-else-if="loading == true">
                            <td colspan="6" class="text-center">
                              <v-skeleton-loader
                                type="heading"
                                :loading="loading"
                              />
                            </td>
                          </tr>

                          <tr v-else>
                            <td colspan="6" class="text-center text-red">
                              You have no item
                            </td>
                          </tr>
                        </tbody>
                        <tfoot v-if="cart.length > 0">
                          <tr>
                            <td colspan="3" class="text-right py-1">
                              Sub Total
                            </td>

                            <td colspan="2"></td>

                            <td class="text-center py-1">
                              {{ this.$numberFormat(subTotal) }}
                            </td>

                            <td colspan="2"></td>
                          </tr>

                          <tr>
                            <td colspan="3" class="text-right">
                              Discount (10 or 10%)
                            </td>

                            <td colspan="2" class="text-right py-1">
                              <v-text-field
                                v-model="discount_per.value.value"
                                density="compact"
                                label="%"
                                hide-details
                                dense
                                autocomplete="off"
                                variant="outlined"
                              />
                            </td>

                            <td class="text-center">
                              {{ this.$numberFormat(discountAmount) }}
                            </td>

                            <td colspan="2" class="text-center py-1"></td>
                          </tr>
                          <tr>
                            <td colspan="3" class="text-right py-1">
                              Tax (10 or 10%)
                            </td>

                            <td colspan="2" class="text-right py-1">
                              <v-text-field
                                v-model="tax_per.value.value"
                                density="compact"
                                label="%"
                                hide-details
                                dense
                                :disabled="taxTypeDisable"
                                autocomplete="off"
                                variant="outlined"
                              />
                            </td>

                            <td class="text-center">
                              {{ this.$numberFormat(taxAmount) }}
                            </td>

                            <td colspan="2" class="text-right pt-2">
                              <v-autocomplete
                                v-model="taxType"
                                density="compact"
                                variant="outlined"
                                :items="includeOrExclude"
                                item-title="label"
                                item-value="value"
                              
                                  :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="3" class="text-right py-1">
                              Vat (10 or 10%)
                            </td>

                            <td colspan="2" class="text-right py-1">
                              <v-text-field
                                v-model="vat_per.value.value"
                                density="compact"
                                label="%"
                                hide-details
                                dense
                                :disabled="vatTypeDisable"
                                autocomplete="off"
                                variant="outlined"
                              />
                            </td>

                            <td class="text-center">
                              {{ this.$numberFormat(vatAmount) }}
                            </td>

                            <td colspan="2" class="text-right pt-2">
                              <v-autocomplete
                                variant="outlined"
                                density="compact"
                                v-model="vatType"
                                :items="includeOrExclude"
                                item-title="label"
                                item-value="value"
                              
                                  :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="3" class="text-right py-1">
                              Grand Total
                            </td>
                            <!-- <td colspan="1"></td> -->
                            <td colspan="2" class="text-right py-1"></td>
                            <td class="text-center py-1">
                              {{ this.$numberFormat(grandTotal) }}
                            </td>
                            <td></td>
                          </tr>
                        </tfoot>
                      </v-table>
                    </v-col>
                  </v-row>

                  <!-- Close Cart Table -->

                  <v-divider class="my-4"></v-divider>
                  <v-row class="pt-0">
                    <v-col cols="6">
                      <v-card class="mt-0 elevation-0 rounded-0">
                        <v-card-title
                          class="d-flex align-center py-2 px-4 bg-blue-grey-lighten-5"
                          style="font-size: 1.1rem;">
                          <span class="">Payment</span>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                          <v-row>
                            <v-col cols="5" sm="5" md="5">
                              Payment Method
                            </v-col>

                            <v-col cols="7" sm="7" md="7">
                              <v-select 
                                v-model="payment_method.value.value" 
                                :items="paymentTypes"
                                item-title="label" 
                                item-value="value" 
                                density="compact"
                                bg-color="grey-lighten-4"
                                variant="outlined" 
                                hide-details
                                autocomplete="off"
                                @update:model-value="onPaymentMethodChange"
                              
                                  :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="5" sm="5" md="5">
                              Payment Head
                            </v-col>

                            <v-col cols="7" sm="7" md="7">
                              <v-select 
                                v-model="payment_acc_head.value.value"
                                :items="getPaymentAccountHeadList"
                                :item-title="(item) => `${item.name}`"
                                item-value="id" 
                                density="compact"
                                bg-color="grey-lighten-4"
                                variant="outlined" 
                                hide-details
                                autocomplete="off"
                              
                                  :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                            </v-col>
                          </v-row>

                          <div v-if="payment_method.value.value === 'BANK' && payment_acc_head.value.value !== null">
                            <v-row class="pt-2">
                              <v-col cols="5" sm="5" md="5">
                                Select Cheque Method
                              </v-col>
                              
                              <v-col cols="7" sm="7" md="7">
                                <v-select
                                  v-model="selectChequeMethod"
                                  :items="getChequeMethod"
                                  item-title="text"
                                  item-value="value"
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  prepend-inner-icon="mdi-cash-multiple"
                                  clearable
                                
                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-select>
                              </v-col>
                            </v-row>
  
                            <v-row class="pt-0 mt-0" v-if="selectChequeMethod === ''">
                              <v-col class="pt-0 mt-0" cols="5" sm="5" md="5" >
                                Enter Cheque Number
                              </v-col>
    
                              <v-col class="pt-0 mt-0" cols="7" sm="7" md="7">
                                <v-text-field
                                  v-model="cheque_no.value.value"
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  hide-details
                                  class="text-right"
                                  prepend-inner-icon="mdi-cash-multiple"
                                  clearable
                                ></v-text-field>
                              </v-col>
                            </v-row>
  
                            <v-row v-else>
                              <v-col class="pt-0 mt-0" cols="5" sm="5" md="5">
                                Select Cheque No
                              </v-col>

                              <v-col class="pt-0 mt-0" cols="7" sm="7" md="7">
                                <v-select
                                  v-model="cheque_id.value.value"
                                  :items="getChequeList"
                                  :item-title="(item) => item.cheque_no"
                                  item-value="id"
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  
                                  prepend-inner-icon="mdi-cash-multiple"
                                  clearable
                                
                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-select>
                              </v-col>

                            </v-row>
  
                            <v-row>
                              <v-col class="mt-0 pt-0" cols="5" sm="5" md="5" >
                                Cheque Issue Date
                              </v-col>

                              <v-col class="mt-0 pt-0" cols="7" sm="7" md="7">
                                <v-date-input 
                                  input-format="dd/mm/yyyy" 
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  prepend-icon="" 
                                  prepend-inner-icon="mdi-calendar"
                                  v-model="cheque_issue_date.value.value" 
                                  variant="outlined"
                                  hide-details="auto"
                                  :error-messages="cheque_issue_date.errorMessage.value"
                                  autocomplete="off"
                                ></v-date-input>
                              </v-col>
                            </v-row>
                          </div>

                          <!-- <v-row v-if="payment_method.value.value === 'MOBILE_BANKING'">
                            <v-col cols="5" sm="5" md="5">
                              Mobile Provider
                            </v-col>

                            <v-col  class="mt-0 pt-0" cols="7" sm="7" md="7">
                              <v-autocomplete 
                                density="compact" 
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="mobileProvider.value.value"
                                :items="mobileProviders"
                                item-title="label"
                                item-value="value" 
                                hide-details="auto"
                                :error-messages="mobileProvider.errorMessage.value"
                                autocomplete="off"
                              
                                  :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                              </v-autocomplete>
                            </v-col>
                          </v-row>

                          <v-row v-if="payment_method.value.value === 'MOBILE_BANKING'">
                            <v-col cols="5" sm="5" md="5">
                              Transaction ID
                            </v-col>

                            <v-col  class="mt-0 pt-0" cols="7" sm="7" md="7">
                              <v-text-field
                                density="compact"
                                variant="outlined" 
                                bg-color="grey-lighten-4"
                                label="Transaction ID"
                                v-model="transactionId.value.value"
                                hide-details="auto"
                                :error-messages="transactionId.errorMessage.value"
                                autocomplete="off" 
                              />
                            </v-col>
                          </v-row>   -->
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="6">
                      <v-card class="mt-0 elevation-0 rounded-0">
                        <v-card-text>
                          <v-row>
                            <v-col cols="6" sm="6" md="6">
                              Advance Payment
                            </v-col>

                            <v-col cols="6" sm="6" md="6">
                              <v-text-field 
                                v-model="advance_payment.value.value" 
                                density="compact"
                                type="number" 
                                hide-details
                                bg-color="grey-lighten-4"
                                variant="outlined"
                                autocomplete="off"
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>   
                  </v-row>

                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-row class="pt-2">
                      <v-col cols="8">
                        <v-textarea
                          label="Description"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="remarks.value.value"
                          :error-messages="remarks.errorMessage.value"
                          autocomplete="off"
                          rows="3"
                          clearable
                        ></v-textarea>
                      </v-col>
                      <v-col cols="8">
                        <v-textarea
                          label="Subject"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="subject.value.value"
                          :error-messages="subject.errorMessage.value"
                          autocomplete="off"
                          rows="2"
                          clearable
                        ></v-textarea>
                      </v-col>
                      <v-col cols="8">
                        <v-textarea
                          label="Terms and Condition"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="terms_and_condition.value.value"
                          :error-messages="terms_and_condition.errorMessage.value"
                          autocomplete="off"
                          rows="3"
                          clearable
                        ></v-textarea>
                      </v-col>
                      <v-col cols="4">
                        <v-layout class="justify-end">
                          <v-btn
                            class="bg-grey-darken-1 me-2"
                            variant="flat"
                            @click="submitForm(0)"
                            >DRAFT</v-btn
                          >
                          <v-btn
                            class="bg-primary"
                            variant="flat"
                            @click="submitForm(1)"
                            >POST</v-btn
                          >
                        </v-layout>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import formattedDate from "@/plugins/dateFormatter";
import { useField, useForm } from "vee-validate";
import { getCurrentInstance, ref } from "vue";
import { useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";
import * as yup from "yup";
import { getCompanyInfo } from '@/plugins/helpers'
export default {
  components: {},
  data: () => ({
    panel: [0],
    panel2: [0],
    loading: false,
    errorMessages: "",
    visible: false,
    selectChequeMethod: '',
    search: "",
    selectedImage: null,
    photo_imageFile: "",
    evaluationSelection: false,
    addProduct: false,
    cncMergeSelection: false,
    requsitionSelection: false,
    preview: "/src/assets/no_preview.png",
    cart: [],
    vatType: 1,
    taxType: 1,
    isEditMode: false,
    isFreeItem: false,

    vatTypeDisable: false,
    taxTypeDisable: false,

    types: [
      { id: 1, name: "Local" },
      { id: 2, name: "Import" },
    ],
    paymentTypes: [
      { label: "Cash", value: "CASH" },
      { label: "Bank", value: "BANK" },
      { label: "Mobile Banking", value: "MOBILE_BANKING" }
    ],
    mobileProviders: [
      { label: "Bkash", value: "bkash" },
      { label: "Nagad", value: "nagad" },
      { label: "Rocket", value: "rocket" }
    ],
    includeOrExclude: [
      { value: 1, label: "Include" },
      { value: 2, label: "Exclude" },
      { value: 3, label: "Exempted" },
    ],
  }),
  watch: {
    vatType(val) {
      if (val === 3) {
          this.vat_per.value.value = 0,
          this.vatTypeDisable = true;
      } else {
          this.vatTypeDisable = false;
      }
    },
    taxType(val) {
      if (val === 3) {
          this.tax_per.value.value = 0,
          this.taxTypeDisable = true;
      } else {
          this.taxTypeDisable = false;
      }
    },
    selectChequeMethod(val) {
      const queryId = this.$route.query.id;

      if (queryId) return;
      this.cheque_no.value.value = '';
      this.cheque_id.value.value = null;
    },

    "payment_acc_head.value.value": {
      handler(newVal) {
        if (newVal) {
          this.$store.dispatch("getChequeList", {
            acc_account_head_id: newVal,
          });
        }
      },
    },

    "cheque_id.value.value": {
      handler(newVal) {
        if (newVal) {
          this.$store.dispatch("getChequeById", newVal).then((res) => {
            this.cheque_no.value.value = res[0].cheque_no;
          })
        }
      },
    },
  },
  created() {
    // if (this.$store.getters.getWarehouseList.length === 0) {
      this.$store.dispatch("getWarehouseList");
    // }
    // if (this.$store.getters.getLcBankList.length === 0) {
      this.$store.dispatch("getLcBankList");
    // }
    // if (this.$store.getters.getSupplierList.length === 0) {
      this.$store.dispatch("getSupplierList");
    // }
    // if (this.$store.getters.getProductMapList.length === 0) {
      this.$store.dispatch("getProductMapList");
    // }
    // if (this.$store.getters.getPurposeList.length === 0) {
      this.$store.dispatch("getPurposeList");
    // }
    // if (this.$store.getters.getEmployeeList.length === 0) {
      this.$store.dispatch("getEmployees", {is_all_branch: true});
    // }

    
    // 
    this.$store.dispatch("getOrderablePurchaseRequisitionList");
    //this.$store.dispatch("getSelectedCsQuotationList");
     this.$store.dispatch("getSelectedCsQuotationEvaluationList");
    // this.$store.dispatch("getOrderablePurRequisitionMergeList");

    

    
  },
  computed: {
    getChequeMethod() {
      const method = [
        { text: "Select Cheque No.", value: "enter-cheque" },
        { text: "Enter Cheque No.", value: "" },
      ]
      return method;
    },
    getLcBankList() {
      return this.$store.getters.getLcBankList;
    },
    getChequeList() {
      return this.$store.getters.getChequeList;
    },
    getEmployeeList() {
      return this.$store.getters.getEmployeeList;
    },
    getPurposeList() {
      return this.$store.getters.getPurposeList;
    },
    subTotal() {
      return this.cart.reduce((sum, item) => +sum + +item.total, 0);
    },
    discountAmount() {
      if (!this.discount_per?.value?.value) return 0;

      const val = this.discount_per.value.value.toString().trim();

      if (val.endsWith("%")) {
        const percentage = parseFloat(val.replace("%", ""));
        return (this.subTotal * percentage) / 100 || 0;
      }

      return parseFloat(val) || 0;
    },
    subtotalAfterDiscount() {
      return this.subTotal - this.discountAmount;
    },
    taxAmount() {
      if (!this.tax_per?.value?.value) return 0;

      const val = this.tax_per.value.value.toString().trim();

      if (val.endsWith("%")) {
        const percentage = parseFloat(val.replace("%", ""));
        return (this.subtotalAfterDiscount * percentage) / 100 || 0;
      }

      return parseFloat(val) || 0;
    },
    vatAmount() {
      if (!this.vat_per?.value?.value) return 0;

      const val = this.vat_per.value.value.toString().trim();

      if (val.endsWith("%")) {
        const percentage = parseFloat(val.replace("%", ""));
        return (this.subtotalAfterDiscount * percentage) / 100 || 0;
      }

      return parseFloat(val) || 0;
    },
    grandTotal() {
      const discount = this.discountAmount;
      const vat = this.vatType === 1 ? this.vatAmount : 0;
      const tax = this.taxType === 1 ? this.taxAmount : 0;
      return this.subTotal - discount + vat + tax;
    },

    branchId() {
      return this.$store.getters.getAuthUser.branch_id || null;
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
    getProductMapList() {
      let products = this.$store.getters.getProductMapList;
      return products.filter(
        (item) => item.branch_id == this.branchId && item.status == 1
      );
    },
    getSupplierList() {
      return this.$store.getters.getSupplierList;
    },
    // filteredPurRequisitionList() {
    //   const requisitions = this.$store.getters.getOrderablePurchaseRequisitionList || [];
    //   return requisitions.filter(
    //     (item) => item.branch_id == this.branchId && item.status == 1
    //   );
    // },
    getSelectedCsQuotationList(){
      const quotations = this.$store.getters.getSelectedCsQuotationList || [];
      return quotations.filter(
        (item) => item.branch_id == this.branchId && item.status == 1
      );
    },

    getSelectedCsQuotationEvaluationList(){
      const quotations = this.$store.getters.getSelectedCsQuotationEvaluationList || [];
      return quotations.filter(
        (item) => item.branch_id == this.branchId && item.status == 1
      );
    },
    getOrderablePurRequisitionMergeList(){
      const quotations = this.$store.getters.getOrderablePurRequisitionMergeList || [];
      return quotations;
      // return quotations.filter(
      //   (item) => item.branch_id == this.branchId && item.status == 1
      // );
    },
    getOrderablePurchaseRequisitionList(){
      const requisitions = this.$store.getters.getOrderablePurchaseRequisitionList || [];
      return requisitions;
      // return requisitions.filter(
      //   (item) => item.branch_id == this.branchId && item.status == 1
      // );
    },
    getPaymentAccountHeadList() {
      return this.$store.getters.getPaymentAccountHeadList || [];
    },
  },
  methods: {
    getCurrencyIcon(type) {
        return type == 2 ? 'mdi-currency-usd' : 'mdi-currency-bdt'
    },
    onPaymentMethodChange() {
      if (this.payment_method.value.value) {
        this.$store.dispatch("getPaymentAccountHeadList", { 
          type: this.payment_method.value.value 
        });
        this.payment_acc_head.value.value = null;
      }
    },
    addCart() {
      let cartInd = this.cart.findIndex(
        (p) => p.product_id == this.product_id.value.value
      );
      if (this.product_id.value.value == null) {
        toast.error("Please select a Product");
        this.cartReset();
        return false;
      }
      if (cartInd > -1) {
        toast.error("Product already added in cart");
        this.cartReset();
        return false;
      }

      let product = this.getProductMapList.find(
        (item) => item.product_id == this.product_id.value.value
      );
      product = product.product;

      let item = {
        product_id: this.product_id.value.value,
        product_name: product.name,
        product_code: product.code,
        qty: 1,
        free_qty: 0,
        unit_id: product.unit_id,
        unit_name: product.unit.name,
        rate: product.latest_purchase_rate,
        total: product.latest_purchase_rate * 1,
        cs_quotation_details_id: null,
        req_merge_details_id: null,
      };

      this.cart.push(item);
      this.$nextTick(() => {
        this.cartReset();
      });
    },
    removeFromCart(index) {
      if (confirm("Are You Sure?")) {
        this.cart.splice(index, 1);
      }
    },
    cartReset() {
      this.product_id.value.value = null;
    },
    onRequisitionTypeChange(type){
      this.cart = [];
      if(type == 'with_cs'){
        this.evaluationSelection =  true;
        this.cncMergeSelection = false;
        this.addProduct = false;
        this.requsitionSelection = false;
      }
      if(type == 'without_cs'){
        this.evaluationSelection =  false;
        this.cncMergeSelection = false;
        this.addProduct = false;
        this.requsitionSelection = true;
      }
      if(type == 'direct_po'){
        this.evaluationSelection =  false;
        this.cncMergeSelection = false;
        this.requsitionSelection = false;
        this.addProduct = true;
      }
      
    },
    async onQuotationChange(object) {
      var selectedId = object.cs_quotation_master_id;
      if (!selectedId) {
        this.warehouse_id.value.value = null;
        this.purpose_id.value.value = null;
        this.procurer_id.value.value = null;
        this.type_id.value.value = null;
        this.cart = [];
        return;
      }

      try {
        this.$store.commit("SET_LOADING", { color: "primary" });
        const data = await this.$store.dispatch("getCsQuotationById",selectedId);
        //getPurRequisitionById

        this.warehouse_id.value.value = data.warehouse_id || data.warehouse?.id || null;
        this.purpose_id.value.value = data?.purpose_id || null;
        this.procurer_id.value.value = data?.procurer_id || null;
        this.supplier_id.value.value = data.supplier_id || null;
        this.remarks.value.value = data.remarks || "";

        this.cart = [];
        (data.quotation_details || []).forEach((item) => {
          this.cart.push({
            product_id: item.product_id,
            product_name: item.product?.name || "",
            qty: item.qty - (item.purchase_qty??0),
            free_qty: 0,
            unit_id: item.product?.unit_id || "",
            unit_name: item.product?.unit?.name || "",
            rate: item.product.latest_purchase_rate,
            total: (item.qty - (item.purchase_qty??0)) * item.product.latest_purchase_rate,
            cs_quotation_details_id: item.id ?? null,
            req_merge_details_id: null,
            requisition_details_id:null,
          });
        });
        this.$store.commit("UNSET_LOADING");
      } catch (error) {
        console.error("Failed to load requisition data:", error);
      }
    },

    onRequesitionChange(requsition_master_id) {
      var selectedId = requsition_master_id;
      if (!selectedId) {
        this.warehouse_id.value.value = null;
        this.purpose_id.value.value = null;
        this.procurer_id.value.value = null;
        this.type_id.value.value = null;
        this.cart = [];
        return;
      }

      this.$store.commit("SET_LOADING", { color: "primary" });
      this.$store.dispatch("getPurRequisitionById",selectedId).then((data) => {
        this.warehouse_id.value.value = data.warehouse_id || data.warehouse?.id || null;
        this.purpose_id.value.value = data?.purpose_id || null;
        this.procurer_id.value.value = data?.procurer_id || null;
        this.supplier_id.value.value = data.supplier_id || null;
        this.remarks.value.value = data.remarks || "";

        this.cart = [];
        (data.requisition_details || []).forEach((item) => {
          this.cart.push({
            product_id: item.product_id,
            product_name: item.product?.name || "",
            product_code: item.product?.code || "",
            qty: item.qty - (item.purchase_qty??0),
            free_qty:0,
            unit_id: item.product?.unit_id || "",
            unit_name: item.product?.unit?.name || "",
            rate: item.product.latest_purchase_rate,
            total: (item.qty - (item.purchase_qty??0)) * item.product.latest_purchase_rate,
            cs_quotation_details_id: null,
            req_merge_details_id: null,
            requisition_details_id : item.id ?? null,
          });
        });
        this.$store.commit("UNSET_LOADING");
      });
    },

    async onCncChange(rqe_merge_mastre_id){
      var selectedId = rqe_merge_mastre_id;
      if (!selectedId) {
        this.warehouse_id.value.value = null;
        this.purpose_id.value.value = null;
        this.procurer_id.value.value = null;
        this.type_id.value.value = null;
        this.cart = [];
        return;
      }

      try {
        this.$store.commit("SET_LOADING", { color: "primary" });
        const data = await this.$store.dispatch("getPurRequisitionMergeById",selectedId);
        //getPurRequisitionById

        this.warehouse_id.value.value = data.warehouse_id || data.warehouse?.id || null;
        this.purpose_id.value.value = data?.purpose_id || null;
        this.procurer_id.value.value = data?.procurer_id || null;
        this.supplier_id.value.value = data.supplier_id || null;
        this.remarks.value.value = data.remarks || "";

        this.cart = [];
        (data.pur_req_merge_details || []).forEach((item) => {
          this.cart.push({
            product_id: item.product_id,
            product_name: item.product?.name || "",
            qty: item.quantity - (item.purchase_qty??0),
            free_qty:0,
            unit_id: item.product?.unit_id || "",
            unit_name: item.product?.unit?.name || "",
            rate: item.product.latest_purchase_rate,
            total: (item.quantity - (item.purchase_qty??0)) * item.product.latest_purchase_rate,
            cs_quotation_details_id: null,
            requisition_details_id: null,
            req_merge_details_id: item.id ?? null,
          });
        });
        this.$store.commit("UNSET_LOADING");
      } catch (error) {
        console.error("Failed to load requisition data:", error);
      }
    },

    getRequisitionTypeList() {
      return [
        { value: 'direct_po', label: 'Direct PO' },
        { value: 'with_cs', label: 'With CS' },
        { value: 'without_cs', label: 'Without CS'},
      ];
    },
    getRequisitionType(type) {
      const requisitionTypes = this.getRequisitionTypeList();
      const found = requisitionTypes.find(item => item.value === type);
      return found ? found.label : 'Unknown';
    },

  },
  setup() {
    const { proxy } = getCurrentInstance();
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        purchase_date: yup.date().required().label("Purchase Order Date"),
        shipping_date: yup.date().nullable().label("Shipping Date"),
        warehouse_id: yup.number().positive().integer().required().label("Warehouse"),
        // csQuotationEvaluation: yup.object({ id: yup.number().required(), cs_quotation_master_id: yup.number().required(),}).required().label("Cs Evaluation"),
        // req_merge_master_id: yup.number().required().label('CNC Merge'),
        // requsition_master_id: yup.number().required().label("Purchase Requisition"),
        requisition_type: yup.string().required().label('Requisition type'),
        purchase_type: yup.string().required().label('PO type'),
        supplier_id: yup.number().positive().integer().required().label("Supplier Name"),
      }),
    });

    const product_id = useField("product_id");
    const pur_order_master_id = useField("pur_order_master_id");
    const purchase_type = useField("purchase_type");
    const employee_id = useField("employee_id");
    const warehouse_id = useField("warehouse_id");
    const purpose_id = useField("purpose_id");
    const procurer_id = useField("procurer_id");
    const payment_bank_id = useField("payment_bank_id");
    const csQuotationEvaluation = useField("csQuotationEvaluation");
    const req_merge_master_id = useField("req_merge_master_id");
    const requsition_master_id = useField("requsition_master_id");
    const requisition_type  =  useField("requisition_type");
    const ref_no  =  useField("ref_no");
    const supplier_id = useField("supplier_id");
    const shipping_date = useField("shipping_date");

    const discount_per = useField("discount_per");
    const discount_amount = useField("discount_amount");
    const tax_amount = useField("tax_amount");
    const tax_per = useField("tax_per");
    const tax_type = useField("tax_type");
    const vat_amount = useField("vat_amount");
    const vat_per = useField("vat_per");
    const vat_type = useField("vat_type");
    const grand_total = useField("grand_total");

    const status = useField("status");
    const payment_method = useField("payment_method");
    const payment_acc_head = useField("payment_acc_head");
    const advance_payment = useField("advance_payment");
    const cheque_no = useField("cheque_no");
    const cheque_id = useField("cheque_id");
    const cheque_issue_date = useField("cheque_issue_date");
    const issuing_bank_name = useField("issuing_bank_name");
    const issuing_branch_name = useField("issuing_branch_name");
    const issuing_account_no = useField("issuing_account_no");
    const mobileProvider = useField("mobileProvider");
    const transactionId = useField("transactionId");

    const purchase_date = useField("purchase_date");
    const remarks = useField("remarks");
    const subject = useField("subject");
    const terms_and_condition = useField("terms_and_condition");
    const purOrder_by = useField("purOrder_by");
    const purOrder_by_mobile = useField("purOrder_by_mobile");
    const purOrder_by_email = useField("purOrder_by_email");
    const total = useField("total");
    const errorMessages = ref("");
    const cart = ref([]);
    const loading = ref("");
    const buttonText = ref("");
    buttonText.value = "Save";
    const store = useStore();
    const router = useRouter();

    const currentStatus = ref(0);
 
    const submitForm = (btnStatus) => {
      // Keep track of the status chosen (0 = DRAFT, 1 = POST)
      currentStatus.value = btnStatus;
      // Explicitly set the form field so it gets into `values`
      status.value.value = btnStatus;
      submit();
    };

    const normalizeNumericInput = (input) => {
      if (input === undefined || input === null) return null;
      const val = input.toString().trim();
      if (!val) return null;
      if (val.endsWith("%")) {
        return parseFloat(val.replace("%", "")) || 0;
      }
      return parseFloat(val) || 0;
    };

    const getDiscountType = (input) => {
      if (input === undefined || input === null) return null;
      const val = input.toString().trim();
      if (!val) return null;
      return val.endsWith("%") ? 1 : 2;
    };

    const onSupplierChange = (supplierId) => {
      if (!supplierId) {
        procurer_id.value.value = null;
        return;
      }

      const getSupplierList = store.getters.getSupplierList;

      const supplier = getSupplierList.find(
        s => Number(s.id) === Number(supplierId)
      );

      console.log("Selected Supplier:", supplier);

      procurer_id.value.value = supplier?.dealing_person_id ?? null;
    };


    const getValueType = (input) => {
      // Determine if value is percentage (1) or flat (2)
      // 1 = percent, 2 = flat, null = no value
      if (input === undefined || input === null || input === "") {
        console.log("getValueType: input is empty/null/undefined");
        return null;
      }
      
      // Convert to string and trim
      const val = String(input).trim();
      if (!val || val === "0") {
        console.log("getValueType: value is empty or zero");
        return null;
      }
      
      // Check if it ends with % symbol (case-insensitive check)
      const isPercent = val.endsWith("%") || val.endsWith("% ");
      const result = isPercent ? 1 : 2;
      console.log("getValueType check:", { 
        originalInput: input, 
        stringValue: val, 
        endsWithPercent: isPercent, 
        result: result,
        resultType: result === 1 ? "PERCENT" : "FLAT"
      });
      return result;
    };

    const submit = handleSubmit((values) => {
      // Ensure status is always present in payload
      values.status = status.value.value ?? currentStatus.value ?? 0;

      
      values.sub_total = proxy.subTotal;
      values.discount_amount = proxy.discountAmount;
      values.discount_type = getDiscountType(discount_per.value.value);
      values.discount_per = normalizeNumericInput(discount_per.value.value);

      values.tax_amount = proxy.taxAmount;
      values.tax_type = proxy.taxType;
      // Get value type BEFORE normalizing (need original value with % if present)
      const taxPerRawValue = tax_per.value.value;
      console.log("Tax - Raw input value:", taxPerRawValue, "Type:", typeof taxPerRawValue);
      values.tax_value_type = getValueType(taxPerRawValue);
      values.tax_per = normalizeNumericInput(taxPerRawValue);

      values.vat_amount = proxy.vatAmount;
      values.vat_type = proxy.vatType;
      // Get value type BEFORE normalizing (need original value with % if present)
      const vatPerRawValue = vat_per.value.value;
      console.log("VAT - Raw input value:", vatPerRawValue, "Type:", typeof vatPerRawValue);
      values.vat_value_type = getValueType(vatPerRawValue);
      values.vat_per = normalizeNumericInput(vatPerRawValue);

      values.requisition_type = requisition_type.value.value;
      values.ref_no = ref_no.value.value;
      
      values.cs_evaluation_result_master_id =  csQuotationEvaluation.value.value?.id;
      values.cs_quotation_master_id = csQuotationEvaluation.value.value?.cs_quotation_master_id;
      values.req_merge_master_id = req_merge_master_id.value.value;
      values.requisition_master_id = requsition_master_id.value.value;

      // console.log("CARTTTTTTTTTTTTTTTTTTTTTTT");
      // console.log(cart.value);

      values.grand_total = proxy.grandTotal;
      values.cart = cart.value;
      values.purchase_date = formattedDate(purchase_date.value.value);
      values.shipping_date = formattedDate(shipping_date.value.value);

      if (payment_method.value.value === "BANK") {
        if (proxy.selectChequeMethod === '') {
          // Dropdown selection - send cheque_id
          values.cheque_id = cheque_id.value.value;
          values.cheque_no = cheque_no.value.value;
          values.cheque_issue_date = formattedDate(cheque_issue_date.value.value);
        } else if (proxy.selectChequeMethod === 'enter-cheque') {
          // Manual entry - send cheque_no
          values.cheque_id = null;
          values.cheque_no = cheque_no.value.value;
          values.cheque_issue_date = formattedDate(cheque_issue_date.value.value);
        }
      } else {
        values.cheque_id = null;
        values.cheque_no = null;
        values.cheque_issue_date = null;
      }

      store
        .dispatch("saveUpdatePurOrder", values)
        .then((response) => {
          resetForm();
          buttonText.value = "Save";
          cart.value = [];
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "purchase-record" });
          }, 2000);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });

    return {
      submitForm,
      submit,
      onSupplierChange,
      product_id,
      purchase_date,
      shipping_date,
      remarks,
      subject,
      terms_and_condition,
      purchase_type,

      discount_per,
      discount_amount,
      tax_amount,
      tax_per,
      tax_type,
      vat_amount,
      vat_per,
      vat_type,
      grand_total,

      status,
      payment_method,
      payment_acc_head,
      advance_payment,
      cheque_no,
      cheque_id,
      cheque_issue_date,
      issuing_bank_name,
      issuing_branch_name,
      issuing_account_no,
      mobileProvider,
      transactionId,

      total,
      cart,
      purOrder_by,
      purOrder_by_mobile,
      purOrder_by_email,
      errorMessages,
      employee_id,
      warehouse_id,
      purpose_id,
      procurer_id,
      payment_bank_id,
      csQuotationEvaluation,
      req_merge_master_id,
      requsition_master_id,
      requisition_type,
      ref_no,
      supplier_id,
      pur_order_master_id,
      buttonText,
      loading,
      store,
    };
  },

  async mounted() {
    this.employee_id.value.value = "";
    let user = this.$store.getters.getAuthUser;
    this.purOrder_by.value.value = user.full_name;
    this.purOrder_by_mobile.value.value = user.mobile;
    this.purOrder_by_email.value.value = user.email;

    this.isFreeItem = getCompanyInfo()?.is_free_item ?? false;

    const queryId = this.$route.query.id;
    const paramId = this.$route.params.id;

    if(paramId){
      this.isEditMode = true;
      this.requisition_type.value.value = 'with_cs';
      this.onRequisitionTypeChange('with_cs');
      await this.$store.dispatch('getSelectedCsQuotationEvaluationList');
      const quotations = this.$store.getters.getSelectedCsQuotationEvaluationList || [];
      const selectedItem = quotations.find(item => item.id == paramId);
      if (selectedItem) {this.csQuotationEvaluation.value.value = selectedItem; this.onQuotationChange(selectedItem)}
    } else if (queryId) {
      this.isEditMode = true;
      this.$nextTick(() => {
        this.$store.dispatch("getPurOrderById", queryId) //getPurOrderById
          .then((data) => {
            let purOrder = data;
            // Master fields
            this.pur_order_master_id.value.value = purOrder.id;
            this.purchase_date.value.value = purOrder.purchase_date
              ? new Date(purOrder.purchase_date)
              : new Date();
            this.shipping_date.value.value = purOrder.shipping_date
              ? new Date(purOrder.shipping_date)
              : new Date();
            this.purchase_type.value.value = parseInt(purOrder.purchase_type);
            this.warehouse_id.value.value = purOrder.warehouse_id ?? null;
            this.purpose_id.value.value = purOrder.purpose_id ?? null;
            this.procurer_id.value.value = purOrder.procurer_id ?? null;
            this.payment_bank_id.value.value = purOrder.payment_bank_id ?? null;
            this.csQuotationEvaluation.value.value = purOrder?.cs_evaluation ?? null;
            this.req_merge_master_id.value.value = purOrder?.req_merge_master_id ?? null;
            this.requsition_master_id.value.value = purOrder?.requisition_master_id ?? null;
            this.requisition_type.value.value = purOrder.requisition_type;
            this.ref_no.value.value = purOrder.ref_no;
            this.advance_payment.value.value = purOrder.paid;
            
            this.supplier_id.value.value = purOrder.supplier_id ?? null;

            if(this.requisition_type.value.value == 'without_cs')
              this.$store.dispatch("getOrderablePurchaseRequisitionList", {id: purOrder?.requisition_master_id ?? null});

            if(this.requisition_type.value.value == 'with_cs')
              this.$store.dispatch("getSelectedCsQuotationEvaluationList", {id: purOrder?.cs_evaluation ?? null});

            this.status.value.value = purOrder.status;

            // Discount / Tax / VAT fields
            this.discount_per.value.value =
              purOrder.discount_per ?? this.discount_per.value.value;
            this.tax_per.value.value =
              purOrder.tax_per ?? this.tax_per.value.value;
            this.vat_per.value.value =
              purOrder.vat_per ?? this.vat_per.value.value;

            this.taxType = purOrder.tax_type
              ? parseInt(purOrder.tax_type)
              : this.taxType;
            this.vatType = purOrder.vat_type
              ? parseInt(purOrder.vat_type)
              : this.vatType;

            if(this.requisition_type.value.value == 'with_cs'){
              this.evaluationSelection =  true;
              this.cncMergeSelection = false;
              this.addProduct = false;
              this.requsitionSelection = false;
            }
            if(this.requisition_type.value.value == 'without_cs'){
              this.evaluationSelection =  false;
              this.cncMergeSelection = false;
              this.requsitionSelection = true;
              this.addProduct = false;
            }
            if(this.requisition_type.value.value == 'direct_po'){
              this.evaluationSelection =  false;
              this.cncMergeSelection = false;
              this.requsitionSelection = false;
              this.addProduct = true;
            }

            this.payment_method.value.value = purOrder?.voucher_master?.payment_method;

            this.onPaymentMethodChange();

            this.payment_acc_head.value.value = purOrder?.voucher_master?.payment_acc_account_head_id;

            if (purOrder?.voucher_master?.cheque_id) {
              this.selectChequeMethod = 'enter-cheque';
              this.cheque_id.value.value = purOrder?.voucher_master?.cheque_id;
            } else {
              this.selectChequeMethod = '';
              this.cheque_no.value.value = purOrder?.voucher_master?.cheque_no;
            }

            this.cheque_issue_date.value.value = purOrder?.voucher_master?.cheque_date;

            this.cart = [];
            (purOrder.pur_order_details || []).forEach((item) => {
              this.cart.push({
                product_id: item.product_id,
                product_name: item.product?.name || "",
                product_code: item.product?.code || "",
                qty: item.qty,
                free_qty: item.free_qty,
                unit_id: item.product?.unit?.id || "",
                unit_name: item.product?.unit?.name || "",
                rate: item.rate,
                total: item.qty * item.rate,
                cs_quotation_details_id: item?.cs_quotation_details?.id ?? null,
                req_merge_details_id: item?.cnc_mergin_details?.id ?? null,
                requisition_details_id: item?.requisition_details_id ?? null,
              });
            });

            this.remarks.value.value = purOrder.remarks || "";
            this.subject.value.value = purOrder.subject || "";
            this.terms_and_condition.value.value = purOrder.terms_and_condition || "";
          })
          .catch((error) => {
            console.error("Failed to fetch purchase order:", error);
          });
      });
    } else {
      // Fresh create mode
      this.isEditMode = false;
      this.pur_order_master_id.value.value = "";
      this.purchase_date.value.value = new Date();
      this.shipping_date.value.value = new Date();
    }
  },
};
</script>
